import React from 'react';
import { Typography, Box, Paper } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import Scoreboard from '../components/Scoreboard';

export const DashboardPage: React.FC = () => {
    const { user } = useAuth();

    return (
        <Box>
            <Typography variant="h4" gutterBottom>
                Dashboard
            </Typography>
            
            {/* Scoreboard Section */}
            <Box sx={{ mt: 4 }}>
                <Scoreboard />
            </Box>

            {/* User Info Section */}
            <Paper sx={{ p: 3, mt: 4 }}>
                <Typography variant="h6" gutterBottom>
                    Welcome, {user?.email}!
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Your role is: {user?.role}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    Last login: {user?.lastLogin ? new Date(user.lastLogin).toLocaleString() : 'First time login'}
                </Typography>
            </Paper>
        </Box>
    );
};
